import { SCREEN_TYPE } from '../util/util';

const initialState = {
	mediaName: '',
	accountId: '',
	currentMediaId: '',
	currentConfigId: '',
	videoDownloadUrl: '',
	videoHoverUrl: '',
	isMediaLive: false,
	reactionUrl: '',
	mediaType: 'video',
	mediasData: [],
	sceneConfig: {
		currentScene: null,
		nextScene: null,
	},
	scenario: null,
	screenType: SCREEN_TYPE.huge,
	shouldGetDataIndividually: false,
	isPollExpanded: false,
	chapters: [],
	restrictedToken: null,
	isMaintainProportions: false,
	relatedMediasOfScene: {},
	openSharingModal: false,
	openSettingMenu: undefined,
	shouldChangeCurrentMedia: false,
	changeSceneType: '',
	playlistId: '',
	scenePath: [],
	isTransitionLayerEnable: false,
	transitionType: '',
	isTransitionEffectActive: false,
	showCountdownModule: false,
	isTransitionLayerFadeOutAnimateActive: false,
	embedShareSettings: {},
	isChatActivated: true,
	isCloseIncomingMessage: false,
	restrictedMedias: []
};

const configurationReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_POLL_EXPANDED':
			return {
				...state,
				isPollExpanded: action.isPollExpanded,
			};
		case 'SET_SCREEN_TYPE':
			return {
				...state,
				screenType: action.screenType,
			};
		case 'SET_SCENARIO':
			return {
				...state,
				scenario: action.scenario,
			};
		case 'SET_MEDIA_TYPE':
			return {
				...state,
				mediaType: action.mediaType,
			};
		case 'SET_SCENARIO_THUMBNAIL':
			return {
				...state,
				thumbnailUrl: action.thumbnailUrl,
			};
		case 'SET_SCENE_CONFIG':
			return {
				...state,
				sceneConfig: action.sceneConfig,
			};
		case 'SET_MEDIA_NAME':
			return {
				...state,
				mediaName: action.mediaName,
			};
		case 'SET_REACTION_URL':
			return {
				...state,
				reactionUrl: action.reactionUrl,
			};
		case 'SET_VIDEO_DOWNLOAD_URL':
			return {
				...state,
				videoDownloadUrl: action.videoDownloadUrl,
			};
		case 'SET_VIDEO_HOVER_URL':
			return {
				...state,
				videoHoverUrl: action.videoHoverUrl,
			};
		case 'SET_ACCOUNT_ID':
			return {
				...state,
				accountId: action.accountId,
			};
		case 'SET_CURRENT_MEDIA_ID':
			return {
				...state,
				currentMediaId: action.currentMediaId,
			};
		case 'SET_PLAYLIST_ID':
			return {
				...state,
				playlistId: action.playlistId,
			};
		case 'SET_MEDIAS_DATA':
			return {
				...state,
				mediasData: action.mediasData,
			};
		case 'SET_RELATED_MEDIAS_OF_SCENE':
			return {
				...state,
				relatedMediasOfScene: action.relatedMediasOfScene,
			};
		case 'SET_SHOULD_GET_DATA_INDIVIDUALLY':
			return {
				...state,
				shouldGetDataIndividually: action.shouldGetDataIndividually,
			};
		case 'SET_CURRENT_CONFIG_ID':
			return {
				...state,
				currentConfigId: action.currentConfigId,
			};
		case 'SET_IS_MEDIA_LIVE':
			return {
				...state,
				isMediaLive: action.isMediaLive,
			};
		case 'SET_MEDIA_CHAPTERS':
			return {
				...state,
				chapters: action.chapters,
			};
		case 'SET_RESTRICTED_TOKEN':
			return {
				...state,
				restrictedToken: action.restrictedToken,
			};
		case 'MAINTAIN_PROPORTIONS':
			return {
				...state,
				isMaintainProportions: action.isMaintainProportions,
			};
		case 'SET_OPEN_SHARING_MODAL':
			return {
				...state,
				openSharingModal: action.openSharingModal,
			};
		case 'SET_OPEN_SETTING_MENU':
			return {
				...state,
				openSettingMenu: action.openSettingMenu,
			};
		case 'SHOULD_RESET_CURRENT_MEDIA':
			return {
				...state,
				shouldChangeCurrentMedia: action.shouldChangeCurrentMedia,
			};
		case 'SET_CHANGE_SCENE_TYPE':
			return {
				...state,
				changeSceneType: action.changeSceneType,
			};
		case 'SET_VIEWER_ENGAGEMENT_MODULE_ACTIVATED':
			return {
				...state,
				viewerEngagementModuleActivated: action.viewerEngagementModuleActivated,
			};
		case 'SET_CHAT_ACTIVATED':
			return {
				...state,
				isChatActivated: action.isChatActivated,
			};
			case 'SET_CHAT_CLOSE_INCOMING_MESSAGE':
			return {
				...state,
				isCloseIncomingMessage: action.isCloseIncomingMessage,
			};
		case 'UPDATE_SCENE_HISTORY':
			return {
				...state,
				scenePath: [...state.scenePath, action.newPath],
			};
		case 'SET_SCENE_HISTORY':
			return {
				...state,
				scenePath: action.scenePath,
			};
		case 'SET_TRANSITION_LAYER':
			return {
				...state,
				isTransitionLayerEnable: action.isActive,
			};
		case 'SET_TRANSITION_OUT_TYPE':
			return {
				...state,
				transitionType: action.transitionType,
			};
		case 'SET_SHOWN_COUNTDOWN':
			return {
				...state,
				showCountdownModule: action.showCountdownModule,
			};
		case 'SET_EMBED_SHARE_SETTINGS':
			return {
				...state,
				embedShareSettings: action.embedShareSettings,
			};
		case 'SET_FADE_OUT_TRANSITION_LAYER':
			return {
				...state,
				transitionType: action.transitionType,
			};
		case 'SET_TRANSITION_EFFECT_STATUS':
			return {
				...state,
				isTransitionEffectActive: action.isActive,
			};
		case 'SET_RESTRICTED_MEDIAS':
			return {
				...state,
				restrictedMedias: action.restrictedMedias,
			};
		default:
			return state;
	}
};

export default configurationReducer;
